module.exports = __webpack_public_path__ + "static/img/2019.005e559.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/companyprofilepic/2019.jpg
// module id = v4Oc
// module chunks = 51